export default __webpack_public_path__ + "static/media/heart.74bfebfc.svg";